/*=========================================================================================
  File Name: module-usertax-mutations.js
  Description: UserTax Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */
import { MSEnum } from '@/common/enumeration';
import msDateUtil from '@/components/msdatepicker/msDateUtil';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';

export default {
	resetInvoiceList(state) {
		state.Invoices = [];
		state.InvoicesTotal = 0;
	},
	updateInvoices(state, res) {
		let result = res.data;
		state.Invoices = result && result.Data ? result.Data : [];
		if (res.isGetTotal) {
			// API có lấy ds hóa đơn có lấy thông tin tổng hóa đơn
			state.InvoicesTotal = result.Total;
		} else if (result && result.Total) {
			state.InvoicesTotal = result.Total ? result.Total : state.InvoicesTotal;
		}
	},
	updateTotalPage(state, res) {
		state.InvoicesTotal = res || 0;
	},

	updateSummaries(state, res) {
		state.Summaries = res;
	},
	updateAccountDate(state, res) {
		if (res && res.LstInv && res.LstInv.length > 0) {
			res.LstInv.forEach(invoiceId => {
				let invIndex = state.Invoices.findIndex(item => {
					return item.InvoiceId == invoiceId;
				});
				if (invIndex >= 0) {
					if (res.IsDeleted) {
						state.Invoices[invIndex].AccountingDate = null;
						state.Invoices[invIndex].RefNo = '';
						state.Invoices[invIndex].Accountant = '';
					} else {
						let date = msDateUtil.parseDateTimeToString(res.AccountingDate, 'YYYY-MM-DDTHH:mm:ssZ');
						state.Invoices[invIndex].AccountingDate = date;
						state.Invoices[invIndex].RefNo = res.RefNo;
						state.Invoices[invIndex].Accountant = res.Accountant;
					}
				}
			});
		}
	},

	updateNote(state, res) {
		if (res && res.ListInvoiceId) {
			res.ListInvoiceId.forEach(invoiceId => {
				let invIndex = state.Invoices.findIndex(item => {
					return item.InvoiceId == invoiceId;
				});
				if (invIndex >= 0) {
					state.Invoices[invIndex].Noted = res.Noted;
				}
			});
		}
	},

	updateInvAcceptCheckingResult(state, res) {
		let invIndex = state.Invoices.findIndex(item => item.InvoiceId == res.InvoiceId);
		if (invIndex >= 0 && res && res.Status && res.Status != state.Invoices[invIndex].Status) {
			state.Invoices[invIndex].Status = res.Status;
			EventBusGlobal.$emit(GlobalEventName.ReloadDetail, state.Invoices[invIndex]);
		}
	},

	updateSizePdf(state, res) {
		state.sizePdf = res;
	},
	updateStickInList(state, res) {
		let invIndex = state.Invoices.findIndex(item => {
			return item.InvoiceId == res.InvoiceId;
		});
		if (invIndex >= 0) {
			if (res.Stick.Checked) {
				state.Invoices[invIndex].Sticks.push(res.Stick.StickId);
			} else {
				let stickIndex = state.Invoices[invIndex].Sticks.findIndex(item => {
					return item == res.Stick.StickId;
				});
				if (stickIndex >= 0) {
					state.Invoices[invIndex].Sticks.splice(stickIndex, 1);
				}
			}
		}
	},

	updateLoadingTotalRecords(state, res) {
		state.IsLoadingTotalRecords = res;
	},

	updateInvoiceSearch(state, res) {
		state.InvoiceSearch = res;
	},

	updateDowloadEmails(state, res) {
		state.DowloadEmails = res;
	},

	updateInvoiceInfoXml(state, res) {
		state.InvoiceInfoXml = res;
	},

	updateCostTypes(state, res) {
		state.CostTypes = res;
	}
};
